module.exports = __webpack_public_path__ + "img/amor-arm-1.02728d0a.png";